import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Button } from './Button'

const FooterWrapper = styled.section`
  max-width: 1366px;
  margin: 0 auto;
  padding: 0 80px;
  @media (max-width: 992px) {
    padding: 0 20px;
  }
`
const TopFooter = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 40px 0;
  & div.address {
    padding: 0 0 0 60px;
    max-width: 300px;
  }
  & a {
    font-size: 16px;

    line-height: 1.63;
    letter-spacing: 0.1px;
    color: #999999;
    transition: 0.2s linear;
    & > img {
      width: 65px;
    }
  }
  & a:hover {
    color: #fff;
  }
  & p {
    color: #ffffff;

    line-height: 1.6;
    letter-spacing: 1.4px;
    padding-bottom: 8px;
  }
`
const BottomFooter = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 40px 0;
  background-color: #333333;
  & > div {
    display: flex;
    flex-direction: column;
  }
  & a {
    text-decoration: none;
    color: #fff;
    padding-bottom: 8px;
    color: #999999;
    line-height: 1.64;
    letter-spacing: 1.4px;
    transition: 0.2s linear;
    &:hover {
      color: #c8c8c8;
    }
  }
`

const LinkFooter = styled(Link)`
  text-decoration: none;
  color: #fff;
  padding-bottom: 8px;
  color: #999999;
  line-height: 1.64;
  letter-spacing: 1.4px;
  transition: 0.2s linear;
  &:hover {
    color: #c8c8c8;
  }
`
const LinkFooterHeading = styled.p`
  text-decoration: none;
  padding: 0 0 20px;

  line-height: 1.64;
  letter-spacing: 1.4px;
  color: #ffffff;
`
const CopyrightWrapper = styled.div`
  display: flex;
  background-color: #333333;
  justify-content: space-between;
  padding: 0;
  align-items: center;
  & > div:nth-child(1) {
    & > p {
      line-height: 1.64;
      letter-spacing: 0.1px;
      text-align: center;
      color: rgba(255, 255, 255, 0.6);
    }
  }
  & > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
    width: 400px;
    & > a {
      text-decoration: none;
      color: white;
      margin: 1em;

      line-height: 1.64;
      letter-spacing: 1.4px;
      text-align: center;
      color: #ffffff;
    }
  }
`
const FooterOuter = styled.footer`
  background: #333333;
`
const ContactWrapper = styled.div`
  & div.socialBox {
    padding-top: 40px;
  }
  & > div:first-child {
    display: flex;
    flex-direction: column;
  }
  & > div:last-child {
    & a {
      padding-bottom: 0;
      padding-right: 20px;
    }
    & a:hover {
      & > svg > path {
        fill: #fff;
      }
    }
  }
`

export class Footer extends PureComponent {
  render() {
    const date_obj = new Date()
    const year = date_obj.getFullYear()
    return (
      <FooterOuter>
        <FooterWrapper>
          <TopFooter>
            <Link to="/">
              <img src={require('../static/brand.svg')} alt="8OM" />
            </Link>
            <div className="address">
              <p>ADDRESS</p>
              <a href="https://goo.gl/maps/dRWMPGmkiAGKyMJk9" target="_blank" rel="noopener noreferrer">
                3rd Floor, Plot No. 8 Balaji Estate, Guru Ravidas Marg, Kalkaji, New Delhi, Delhi 110019
              </a>
            </div>

            <div>
              <p>HELP</p>
              <a href="mailto:harsh@8om.io" target="_top">
                Email - harsh@8om.io
              </a>
              <br />
              <a href="tel:+918076157787">Contact - +91 8076157787</a>
            </div>
            <a href="/contact">
              <Button width={171} background={'#35cc62'} title="contact us" />
            </a>
          </TopFooter>
          <BottomFooter>
            <div>
              <LinkFooterHeading to="/">PAGES</LinkFooterHeading>
              <LinkFooter to="/">HOME</LinkFooter>
              <LinkFooter to="/services">SERVICES</LinkFooter>
              <LinkFooter to="/clients">CLIENTS</LinkFooter>
              <LinkFooter to="/about">ABOUT US</LinkFooter>

              <a href="/about#careers">CAREER</a>
            </div>
            <div>
              <LinkFooterHeading to="/">SERVICES</LinkFooterHeading>
              <LinkFooter to="/services/digital-marketing">DIGITAL MARKETING</LinkFooter>
              <LinkFooter to="/services/web-development">WEB DEVELOPMENT</LinkFooter>
              <LinkFooter to="/services/app-development">APP DEVELOPMENT</LinkFooter>
              <LinkFooter to="/services/experiential-marketing">EXPERIENTIAL MARKETING</LinkFooter>
              <LinkFooter to="/services/web-crawling">WEB CRAWLING</LinkFooter>
              <LinkFooter to="/services/Ux-Ui">UX/UI</LinkFooter>
            </div>
            <div>
              <LinkFooterHeading to="/">PRODUCTS</LinkFooterHeading>
              <LinkFooter to="/trckr">TRCKR</LinkFooter>
              <LinkFooter to="/extract">EXTRACT</LinkFooter>
              <LinkFooter to="/books">BOOKS</LinkFooter>
            </div>
            <ContactWrapper>
              <div>
                <LinkFooterHeading to="/contant">CONTACT</LinkFooterHeading>
                <LinkFooter to="/contact">CONTACT US</LinkFooter>
              </div>
            </ContactWrapper>
          </BottomFooter>
          <CopyrightWrapper>
            <div>
              <p>© {year} 8om All Rights Reserved</p>
            </div>
          </CopyrightWrapper>
        </FooterWrapper>
      </FooterOuter>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js